/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteMyLearnAttemptRequest
 */
export interface CompleteMyLearnAttemptRequest {
    /**
     * **Client-reported and untrusted.** Named for what it is: nothing server-side verifies it.
     * Do not rank a leaderboard on this value without server-side scoring.
     * 
     * The bounds are the storage column, not a game rule: `learn_attempts.client_score` is
     * `numeric(12, 4)`. Without them an arcade-style score like `1000000000` passes validation
     * and Postgres then raises `numeric field overflow` (22003) — a 5xx on a surface where
     * section 5 forbids one, carrying a slug that section 6's exhaustive table does not list.
     * A validator rejecting it up front is the shape the contract already uses everywhere else.
     * 
     */
    clientScore?: number | null;
    /**
     * Arbitrary JSON owned by the frontend. The backend persists and returns it verbatim and
     * never inspects, validates, or migrates it.
     * 
     */
    state?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CompleteMyLearnAttemptRequest interface.
 */
export function instanceOfCompleteMyLearnAttemptRequest(value: object): value is CompleteMyLearnAttemptRequest {
    return true;
}

export function CompleteMyLearnAttemptRequestFromJSON(json: any): CompleteMyLearnAttemptRequest {
    return CompleteMyLearnAttemptRequestFromJSONTyped(json, false);
}

export function CompleteMyLearnAttemptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteMyLearnAttemptRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientScore': json['client_score'] === undefined ? undefined : json['client_score'] === null ? null : json['client_score'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function CompleteMyLearnAttemptRequestToJSON(json: any): CompleteMyLearnAttemptRequest {
    return CompleteMyLearnAttemptRequestToJSONTyped(json, false);
}

export function CompleteMyLearnAttemptRequestToJSONTyped(value?: CompleteMyLearnAttemptRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_score': value['clientScore'],
        'state': value['state'],
    };
}

